import { render, staticRenderFns } from "./TakeOrderIndex.vue?vue&type=template&id=48de27c8"
import script from "./TakeOrderIndex.vue?vue&type=script&lang=js"
export * from "./TakeOrderIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports